import axios from "axios";

export const getProjects = async (path) => {
  const apiUrl = typeof window !== "undefined" ? window.env.EJ_APPS_SEARCH_API : process.env.EJ_APPS_SEARCH_API;
  const url = `${apiUrl}/search/v2/project${path}`;

  const response = await axios.get(url);
  return response.data;
};

export const sendProjectRadarSubscription = async (params) => {
  const url = `${window.env.EJ_APPS_API_HOSTNAME}/e6t/v1/project-radar/subscription`;
  const response = await axios.post(url, params, {
    headers: {
      "Content-Type": "application/json",
    },
  });
  return response.data;
};
